import { EToastType } from 'libs/types/site/IClient';
import { toast } from 'react-toastify';

//display toaster
export function userMessage(type: EToastType, message: string): void {
    const style: Record<string, unknown> = {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        toastId: message
    };
    let timeOut = 1;
    if (toast.isActive(message)) {
        toast.dismiss(message);
        timeOut = 350;
    }
    setTimeout(() => {
        if (type === EToastType.SUCCESS) {
            toast.success(message, style);
        } else if (type === EToastType.ERROR) {
            toast.error(message, style);
        } else if (type === EToastType.WARNING) {
            toast.warn(message, style);
        } else {
            toast(message, style);
        }
    }, timeOut);
}
